import { performGetRequest } from '@atlassian/jira-fetch';
import type { BaseUrl, IssueId } from '@atlassian/jira-shared-types';

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (baseUrl: BaseUrl, parentId: IssueId) =>
	performGetRequest(`${baseUrl}/rest/api/2/issue/${parentId}?fields=subtasks`);
